import qs from 'qs';
import instance from '../axios';

export const changeDescription = (idAvgProduct, description) => {
  const params = {
    id: idAvgProduct,
    description
  }
  return instance.put('/catalogs/product/description', params);
};


export const changeMaker = (params) => {
  return instance.post('/catalogs/product/maker/change', params);
};

